import { useState } from "react";
import { Link } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { getActivation, userSetPassword } from "../services/firebase";

function SignIn() {
  const { userId } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [activated, setActivated] = useState(null);
  const [error, setError] = useState(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { password: "" } });

  // Check activation status on mount
  useState(() => {
    async function checkActivation() {
      const activation = await getActivation(userId);
      setActivated(activation?.activated);
      setError(activation?.error);
      setLoading(false);
    }
    checkActivation();
  }, [userId]);

  async function onSubmit(data) {
    setLoading(true);

    const response = await userSetPassword({
      userId,
      password: data.password,
    });

    setLoading(false);
    if (response.data.success) {
      setSuccess(true);
    } else {
      alert("Failed to set password. Please try again.");
    }
  }

  if (success) {
    return (
      <div className="container">
        <h2 className="mb-2 text-center">Account Setup Complete</h2>
        <p className="text-center">
          Your password has been set successfully. You can now{" "}
          <Link to="/sign-in">sign in</Link>.
        </p>
      </div>
    );
  }

  if (loading) {
    return <div className="loading-screen regular-2xl">Loading...</div>;
  }

  if (activated === true) {
    return (
      <div className="container">
        <h2 className="mb-2 text-center">Account Already Activated</h2>
        <p className="text-center">
          This account has already been activated.
          <br />
          If you've forgotten your password, you can follow this link to&nbsp;
          <Link to="/password-reset">reset your password</Link>.
        </p>
      </div>
    );
  }

  if (error === "not-found") {
    return (
      <div className="container">
        <h2 className="mb-2 text-center">Account not found</h2>
        <p className="text-center">
          Please check the link you received in your email. If you continue to
          have issues,{" "}
          <a href="mailto:support@evviaftercare.com">contact support</a>.
        </p>
      </div>
    );
  }

  return (
    <div className="container">
      <h2 className="mb-2 text-center">Account Setup</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="fieldgroup justify-center">
          <fieldset>
            <label>New Password</label>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "This field is required",
                minLength: {
                  value: 6,
                  message: "Password must be at least 6 characters",
                },
              }}
              render={({ field }) => (
                <input
                  type="password"
                  autoComplete="new-password"
                  minLength="6"
                  required
                  {...field}
                />
              )}
            />
            <span className="input-error">{errors["password"]?.message}</span>
          </fieldset>
        </div>

        <div className="mt-2 text-center">
          <button className="button" type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default SignIn;
